export function headerResetBaseStateRequest() {
  return {
    type: '@headers/RESET_BASE_STATE_REQUEST'
  }
}

export function headerResetBaseStateSuccess() {
  return {
    type: '@headers/RESET_BASE_STATE_SUCCESS'
  }
}

export function headerResetBaseStateFailure() {
  return {
    type: '@headers/RESET_BASE_STATE_FAILURE'
  }
}
